const store2 = require('store2')
/**
 * Copyright (c) 2013 ESHA Research
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * Allows use of the 'overwrite' param on set calls to give an enforced expiration date
 * without breaking existing 'overwrite' functionality.
 *
 * Status: BETA - useful, needs testing
 */
;(function (_) {
	const prefix = 'exp@'
	const suffix = ';'
	const parse = _.parse
	const _get = _.get
	const _set = _.set

	_.parse = function (s) {
		if (s && s.indexOf(prefix) === 0) {
			s = s.substring(s.indexOf(suffix) + 1)
		}
		return parse(s)
	}

	_.expires = function (s) {
		if (s && s.indexOf(prefix) === 0) {
			return parseInt(s.substring(prefix.length, s.indexOf(suffix)), 10)
		}
		return false
	}

	_.when = function (sec) {
		// if sec, return sec->date, else date->sec
		const now = Math.floor(new Date().getTime() / 1000)
		return sec ? new Date((now + sec) * 1000) : now
	}

	_.cache = function (area, key) {
		const s = _get(area, key)
		const sec = _.expires(s)
		if (sec && _.when() >= sec) {
			return area.removeItem(key)
		}
		return s
	}

	_.get = function (area, key) {
		const s = _.cache(area, key)
		return s === undefined ? null : s
	}

	_.set = function (area, key, string, sec) {
		try {
			if (sec) {
				string = prefix + (_.when() + sec) + suffix + string
			}
			_set(area, key, string)
		} catch (e) {
			if (
				e.name === 'QUOTA_EXCEEDED_ERR' ||
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
			) {
				let changed = false
				for (var i = 0, m = area.length; i < m; i++) {
					if (_.cache(area, key) === undefined) {
						changed = true
					}
				}
				if (changed) {
					return _.set.apply(this, arguments)
				}
			}
			throw e
		}
	}
})(store2._)

const storage = store2.namespace('sb')
export default storage
